/** ponytail: localStorage-teller is een drempel, geen slot — wissen reset hem. */
const STORAGE_KEY = "jari-tool-bloom-preview-runs";

export function getPreviewRunCount(): number {
  try {
    const n = Number.parseInt(localStorage.getItem(STORAGE_KEY) ?? "0", 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function incrementPreviewRunCount(): number {
  const next = getPreviewRunCount() + 1;
  try {
    localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    /* ignore quota / private mode */
  }
  return next;
}

/** Vanaf de 3e run, na elke 5 beantwoorde vragen. */
export function shouldShowRepeatNudge(runCount: number, answeredCount: number): boolean {
  return runCount >= 3 && answeredCount > 0 && answeredCount % 5 === 0;
}
